import React from 'react';
import { Box, Chip, Typography, Skeleton } from '@mui/material';
import { Capacitor } from '@capacitor/core';

const Counter = (props) => (
  <Chip
    size="small"
    {...props}
    sx={{
      backgroundColor: '#f7b924',
      fontWeight: 700,
      position: 'absolute',
      left: -7,
      top: -7,
    }}
  />
);

const ToDoStack = ({ onClick, badgeCounter = 0, color = '', name = '', subText = '', isLoading = false }) => {
  const isNative = Capacitor.isNativePlatform();
  const isCurrentCard = badgeCounter > 1;

  const cardSx = {
    position: 'relative',
    backgroundColor: '#fff',
    width: '250px',
    height: '230px',
    borderRadius: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 3,
    padding: 4,
    '&:before': {
      position: 'absolute',
      zIndex: 0,
      top: 0,
      left: 0,
      width: '100%',
      height: '10%',
      content: '""',
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      backgroundColor: color || '',
    },
  };
  const cardTransitionSx = {
    transition: 'all 0.2s ease-in-out',
    '&:active': {
      transform: 'rotate(3deg)',
      transformOrigin: 'center',
    },
  };
  const cardTransitionNativeSx = {
    transition: 'all 0.2s ease-in-out',
    '&:active': {
      transform: isCurrentCard ? 'translateX(-10px) translateY(-10px) scale(0.98)' : 'scale(0.98)',
      transformOrigin: 'center',
    },
  };
  const currentCardSx = {
    zIndex: 10,
    transform: 'translateX(-10px) translateY(-10px)',
  };
  const middleCardSx = {
    position: 'absolute',
    top: 0,
    zIndex: 5,
    transform: 'translateX(-5px) translateY(-5px)',
  };
  const nextCardSx = {
    zIndex: 1,
    top: 0,
    position: 'absolute',
  };
  const cardText = {
    textAlign: 'center',
    fontWeight: 500,
  };

  return (
    <Box sx={{ position: 'relative' }} onClick={onClick}>
      {isLoading && (
        <>
          <Box boxShadow={3} sx={[cardSx, currentCardSx]}>
            <Skeleton width={220} />
          </Box>
          <Box boxShadow={3} sx={[cardSx, middleCardSx]}>
            <Skeleton width={220} />
          </Box>
          <Box boxShadow={3} sx={[cardSx, nextCardSx]}>
            <Skeleton width={220} />
          </Box>
        </>
      )}

      {!isLoading && (
        <>
          <Box
            boxShadow={3}
            sx={[
              cardSx,
              isCurrentCard && currentCardSx,
              isNative && cardTransitionNativeSx,
              !isNative && cardTransitionSx,
            ]}
          >
            <Box>
              <Typography variant="subtitle1" sx={cardText}>
                {name}
              </Typography>
              <Typography variant="subtitle2" sx={cardText}>
                {subText}
              </Typography>
            </Box>
            <Counter label={badgeCounter} />
          </Box>
          {badgeCounter > 1 && <Box boxShadow={3} sx={[cardSx, badgeCounter > 2 ? middleCardSx : nextCardSx]} />}
          {badgeCounter > 2 && <Box boxShadow={3} sx={[cardSx, nextCardSx]} />}
        </>
      )}
    </Box>
  );
};

export default ToDoStack;
